import React, { type ComponentType, lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { merchandisingHeroBannersDashboardAccessControl } from '../access-control/merchandisingAccess.configuration'

const HeroBannersDashboardPage = lazy(
  () =>
    import(
      /* webpackChunkName: "HeroBannersDashboardPage" */
      '../components/hero-banners-dashboard/HeroBannersDashboardPage'
    )
)

export const merchandisingPartnerScopedRouter = (
  <DomainRoute route="merchandising-partner-scoped">
    <DashSwitch>
      <DomainRoute
        exact
        route="merchandising-hero-banners-dashboard"
        component={HeroBannersDashboardPage as ComponentType<any>}
        accessControl={merchandisingHeroBannersDashboardAccessControl}
      />
    </DashSwitch>
  </DomainRoute>
)
